import './_app/resizeTextarea';
import './_app/drag-drop';
import * as Swiper from './_app/swiper';
import { checkInputValue } from './_app/input-hover';
import { validateOptions } from './_app/input-validation';
import { inputsMask } from './_app/input-validation';
import * as RecaptchaValidation from './_app/recaptchaValidation';
import * as Maps from './_app/maps';
import 'regenerator-runtime/runtime';
import * as inputFlashMessage from './_app/input-flash-message';
import * as Order from './_app/order';
import * as InputCart from './_app/input-cart';
import * as InputOrderComment from './_app/input-order-comment';
import * as InputOrderDelivery from './_app/input-order-delivery';
import * as InputInvoiceSlider from './_app/input-invoice-slider';
import * as InputCheckbox from './_app/input-checkbox';
import * as Pagination from './_app/product-pagination';
import * as OnChangeSubmit from './_app/on-change-submit';
import * as ProductTileChange from './_app/product-tile-change';
import * as Rating from './_app/rating';
import * as ProductSlider from './_app/product-slider';
import * as BannerSlider from './_app/banner-slider';
import * as OffCanvasMenu from './_app/off-canvas-menu';
import * as InputSelectAuto from './_app/input-select-auto';
import * as MainMenu from './_app/main-menu';
import * as Configurator from './_app/configurator';
import * as Spinner from './_app/spinner-tools';
import * as InputCarousel from './_app/input-carousel';
import * as TimerTools from './_app/timer-tools';
import * as ShoppingList from './_app/shopping-list';
import * as Toasts from "./_app/toasts";
import * as Clock from './_app/product-clock';
import * as cartGtm4Events from './_app/cartGtmEvents';
import * as FilterOpen from './_app/product-pagination';
import * as OrderDataTables from './_app/orders-dataTable';
import * as InvoicesDataTable from './_app/invoices-dataTable';
import * as ThemeSwitcher from './_app/themeSwitcher';
import * as DescriptionBug from './_app/description-bug';
import * as ArticlePagination from './_app/article-pagination';
import * as Expandable from './_app/expandable';

Spinner.init();
window.PaginationBind = Pagination.bind;
window.zoomImageTimeout = null;

$(window).on('resize', function () {
    InputSelectAuto.autoResize();
    MainMenu.resize();
});

$(function () {
    InputSelectAuto.autoResize();
    MainMenu.resize(true);

    //OffCanvasMenu
    OffCanvasMenu.bind();
    OffCanvasMenu.load();
    // OffCanvasMenu.bindSwipeToClose();

    Swiper.bind();

    InputCarousel.bind();

    //ProductSlider
    ProductSlider.bind();

    //BannerSlider
    BannerSlider.bind();

    //Order
    InputOrderComment.bind();
    InputOrderDelivery.bind();
    Order.bind();

    //main menu
    MainMenu.bind();
    MainMenu.load();

    // check all in this form only, and change state by click
    InputCheckbox.modernCheckAll();

    // bind close and open filter button if user set product filter
    FilterOpen.openFilterBtn()
    FilterOpen.closeFilterBtn();

    // timer init
    TimerTools.init();

    ShoppingList.init();

    Clock.init();

    Toasts.bind();

    RecaptchaValidation.bind();

    DescriptionBug.init();

    // zwijane bloki opisu i cech
    Expandable.bind();

    //flash messages
    inputFlashMessage.bind(document);
    // change submit
    OnChangeSubmit.bind();
    //rating
    Rating.bind(document);
    // //cartGTM
    cartGtm4Events.bind();
    //modals
    Maps.bind();
    //pagination
    Pagination.bind();
    ArticlePagination.bind();
    // sorting
    ProductTileChange.bind();
    //invoice data slider show button
    InputInvoiceSlider.bind();
    // input number
    InputCart.bind();
    //configurator
    Configurator.bind();
    //raty
    InputCart.installmentCalculation();
    //theme switcher
    ThemeSwitcher.bind();
});

$(function () {
    $('.category-lead-show').on('click', function (e) {
        e.preventDefault();
        const text = $(this).text();
        if (text === "Pokaż więcej") {
            $(this).text("Pokaż mniej");
            $(this).siblings('.category-short-lead').css('-webkit-line-clamp', 'none')
        } else {
            $(this).text("Pokaż więcej");
            $(this).siblings('.category-short-lead').css('-webkit-line-clamp', '3')
        }
    });
})


// smooth scroll
$("#productDetails ul li a, .mobile-product-nav ul li a, [data-scroll], #productDetailsNav ul li a").on("click", function () {
    const target = this.hash,
        $target = $(target);
    $("html, body")
        .stop()
        .animate({
            scrollTop: $target.offset().top - 200,
        },
            200,
            function () {

                window.location.hash = target;
            }
        );
}
);

$(function () {
  if ($(".product-price-box-sticky").length !== 0) {
    const priceBox = document.querySelector("#product-price-box");
    const element = document.querySelector("#main-product-box");
    const details = $('#product-price-box-details');

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
            priceBox.classList.add("position-sticky");
            details.addClass("d-none");
        } else {
            priceBox.classList.remove("position-sticky");
            details.removeClass("d-none");
        }
      },
      {
        threshold: 0,
      }
    );

    observer.observe(element);
  }
});

function changeStatus(obj) {
    $('.accordion-knowlage').find('.btn-link').removeClass('active');
    $(obj).addClass('active');
}

window.changeStatus = changeStatus;

$(function () {
    const clipboard = new ClipboardJS('.copy');

    $('.product-share').on('click', function () {
        Toasts.createToast(['success', 'Odnośnik do produktu został skopiowany do schowka']);
    });

    $('.modal').on('show.bs.modal', function () {
        $('html').addClass('overflow-hidden');
    });

    $('.modal').on('hide.bs.modal', function () {
        $('html').removeClass('overflow-hidden');
    });


    let last_scroll_top = 0;
    let el_autohide = $('.autohide');

    function onScroll() {
        let scroll_top = window.scrollY;
        if (scroll_top < last_scroll_top) {
            el_autohide.removeClass('scrolled-down').addClass('scrolled-up');
        } else {
            el_autohide.removeClass('scrolled-up').addClass('scrolled-down');
        }
        last_scroll_top = scroll_top;
    }
    function checkWidth() {
        if ($(window).width() < 600) {
            if (!$(window).data('scroll-listener')) {
                $(window).on('scroll', onScroll);
                $(window).data('scroll-listener', true);
            }
        } else {
            $(window).off('scroll', onScroll);
            $(window).data('scroll-listener', false);
            el_autohide.removeClass('scrolled-down scrolled-up');
        }
    }

    checkWidth();

    $(window).on('resize', checkWidth);

});


// contact map
$(".pin-1").hover(function () {
    $(".pin").removeClass("pin-active");
    $(".map-location").removeClass("map-location-active");
    $(".map-location-1").addClass("map-location-active");
    $(this).addClass("pin-active");
});
$(".pin-2").hover(function () {
    $(".pin").removeClass("pin-active");
    $(".map-location").removeClass("map-location-active");
    $(".map-location-2").addClass("map-location-active");
    $(this).addClass("pin-active");
});
$(".pin-3").hover(function () {
    $(".pin").removeClass("pin-active");
    $(".map-location").removeClass("map-location-active");
    $(".map-location-3").addClass("map-location-active");
    $(this).addClass("pin-active");
});
$(".pin-4").hover(function () {
    $(".pin").removeClass("pin-active");
    $(".map-location").removeClass("map-location-active");
    $(".map-location-4").addClass("map-location-active");
    $(this).addClass("pin-active");
});
$(".pin-5").hover(function () {
    $(".pin").removeClass("pin-active");
    $(".map-location").removeClass("map-location-active");
    $(".map-location-5").addClass("map-location-active");
    $(this).addClass("pin-active");
});

// contact branches
$(".company-branch-button").on('click', function () {
    $(".company-branch:nth-child(n+8)").toggleClass("branch-active");
});

// product list
$(".img-list").on('click', function () {
    $(".check-policy").trigger("click");
    $(".check-newsletter").trigger("click");
});


// check all in this form
$(".check-all-boxes").on('click', function () {
    $(".check-all-parent input:checkbox").prop("checked", this.checked);
});

// input label
$(".form-register").on('keyup', function () {
    const catchInput = $(this).closest(".form-group").find("input").val();

    if (!catchInput) {
        $(this).closest(".form-group").find("label").removeClass("label-active");
    } else {
        $(this).closest(".form-group").find("label").addClass("label-active");
    }
});

// register show more
$("label.show-more-label a.more").on('click', function (e) {
    e.preventDefault();
    const text = $(this).text();
    if (text === "Rozwiń") {
        $(this).text("Zwiń");
        $(this).closest("label").find("span").fadeIn();
    } else {
        $(this).text("Rozwiń");
        $(this).closest("label").find("span").fadeOut();
    }
});

// register show more
$(".rodo label .show-more-label a.more").on('click', function (e) {
    e.preventDefault();
    const text = $(this).text();
    if (text === "Rozwiń") {
        $(this).text("Zwiń");
        $(this).parent().parent().find(".show-more-box").fadeIn();
    } else {
        $(this).text("Rozwiń");
        $(this).parent().parent().find(".show-more-box").fadeOut();
    }
});

// register show more
$(".details-checkbox label .show-more-label a.more").on('click', function (e) {
    e.preventDefault();
    const text = $(this).text();
    if (text === "Rozwiń") {
        $(this).text("Zwiń");
        $(this).parent().parent().find(".show-more-box").fadeIn();
    } else {
        $(this).text("Rozwiń");
        $(this).parent().parent().find(".show-more-box").fadeOut();
    }
});

// close cookies
$("#fr3ex-closecookie").on('click', function () {
    $(".cookies-modal").fadeOut();
});

// product reviev
$(".mobile-review a.read-more").on('click', function (e) {
    e.preventDefault();
    $(this).fadeOut();
    $(this).closest(".mobile-review").find("span").fadeIn();
});

// range input
$('input[type="range"]').on('change', function () {
    const val =
        ($(this).val() - $(this).attr("min")) /
        ($(this).attr("max") - $(this).attr("min"));
    $(this).css(
        "background-image",
        "-webkit-gradient(linear, left top, right top, " +
        "color-stop(" +
        val +
        ", #00aaff), " +
        "color-stop(" +
        val +
        ", #e6e6e6)" +
        ")"
    );
});

$('input[type="number"]').on('keyup', function () {
    const val =
        ($(this).val() - $(this).attr("min")) /
        ($(this).attr("max") - $(this).attr("min"));
    $(this)
        .closest("form")
        .find('input[type="range"]')
        .css(
            "background-image",
            "-webkit-gradient(linear, left top, right top, " +
            "color-stop(" +
            val +
            ", #00aaff), " +
            "color-stop(" +
            val +
            ", #e6e6e6)" +
            ")"
        );
});

// option list moreOptions
$("a.moreOptions").on('click', function (e) {
    e.preventDefault();
    const text = $(this).text();
    if (text === "Pokaż więcej") {
        $(this).html("Pokaż mniej<i class='fa-light fa-lg fa-chevron-up ms-2'></i>");
    } else {
        $(this).html("Pokaż więcej<i class='fa-light fa-lg fa-chevron-down ms-2'>");
    }
});

$(".close-modal").on('click', function (e) {
    e.preventDefault();
    $(".add-review-modal-container").removeClass("modal-opened");
});

const modal = document.getElementsByClassName("add-review-modal-container")[0];
window.onclick = function (e) {
    if (e.target === modal) {
        $(".add-review-modal-container").removeClass("modal-opened");
    }
};

// compare
const compareCount = $(".compare-count");
let compareAmount = 0;
$('.single-product input[type="checkbox"]').on('click', function () {
    if ($(this).prop("checked") === true) {
        compareAmount++;
    } else {
        compareAmount--;
    }
    compareCount.text(compareAmount);
});

// sorting list action
let selectCount = 0;
$(".form-select").on('click', function () {
    selectCount++;
    if ($(this).val() && selectCount > 1) {
        $(".product-list").fadeOut().fadeIn();
        selectCount = 0;
    }
});

// remove .no-js from html tag
$("html").removeClass("no-js");

// cookies
(function ($) {
    $.fn.fr3exCookies = function (options) {
        // methods:
        // PUBLIC:
        const methods = {
            set: function (fun, name, value, days, isSameSite) {
                let expires;

                if (days) {
                    const date = new Date();
                    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                    expires = "; expires=" + date.toGMTString();
                } else {
                    expires = "";
                }
                document.cookie =
                    encodeURIComponent(name) +
                    "=" +
                    encodeURIComponent(value) +
                    expires +
                    "; path=/" + (isSameSite ? "; sameSite=Lax" : "");
            },
            remove: function (fun, name) {
                this.set(name, "", -1);
            },
            get: function (fun, name, def) {
                const nameEQ = encodeURIComponent(name) + "=";
                const ca = document.cookie.split(";");
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) === " ") {
                        c = c.substring(1, c.length);
                    }
                    if (c.indexOf(nameEQ) === 0) {
                        return decodeURIComponent(c.substring(nameEQ.length, c.length));
                    }
                }
                return null;
            },
            version: function () {
                console.log("fr3ex-cookies: version: 0.1");
            },
        };

        if (methods[options]) {
            return methods[options].apply(this, arguments);
        } else if (typeof options === "object" || !options) {
            // Establish our default settings
            var settings = $.extend({
                cookieWarning: true, // true / false
                cookieWarningText: "<p class='fs-5 m-0'>Ta strona korzysta z <a href='/cookies' class='m-0'>ciasteczek</a> w celu zapewnienia jej prawidłowego działania. Potrzebujemy ich, abyś mógł dodać produkt do koszyka albo się zalogować.</p>",
                cookieOptionsContent: `
                    <div class='consentOptions d-none'>
                        <h4 class="my-4">Ustawienia ciasteczek</h4>
                        <div class="d-flex flex-column gap-3"> 
                            <div class="d-flex justify-content-between align-items-center p-3">
                                <p class="m-0">Niezbędne pliki cookies</p>
                                <span>Wymagane</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center p-3">
                                <p class="m-0">Analityczne pliki cookie</p>
                                <label class="toggle-switch">
                                    <input type="checkbox" id="analitics-cookies">
                                    <div class="toggle-switch-background">
                                        <div class="toggle-switch-handle"></div>
                                    </div>
                                </label>
                            </div>
                            <div class="d-flex justify-content-between align-items-center p-3">
                                <p class="m-0">Reklamowe pliki cookie</p>
                                <label class="toggle-switch">
                                    <input type="checkbox" id="ads-cookies">
                                    <div class="toggle-switch-background">
                                        <div class="toggle-switch-handle"></div>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    `,
                cookieOptionButton: "<button class='showOptions btn btn-outline-secondary p-3'>Ustawienia</button>",
                cookieWarningButton: "<a id='fr3ex-closecookie' href='' class='btn p-3'>Akceptuję wszystko</a>",
                cookieCloseOptionButton: "<button class='btn closeOptions d-none p-3 me-4'>Wróć</button>",
                policyLink: null,
                // events:
                cookieWarning_no: "https://proline.pl/polityka-prywatnosci",
                cookieWarning_yes: null,
            },
                options
            );
        }

        return this.each(function () {
            const plugin = this;

            // methods:
            // PRIVATE:
            (this.showCookieWarning = function () {
                const check = $(document).fr3exCookies("get", "fr3ex-cookie");
                if (check === "1") {
                    $(document).fr3exCookies("set", "fr3ex-cookie", 1, 365, true);
                    return;
                }
                window.scrollTo(0, 0);
                $("body").css("position", "relative");

                let message =
                    "<div id='fr3ex-cookiewarning' class='cookies-modal-background'><div class='cookies-modal-outer minimididesign-cookies'><div class='cookies-modal-inner'><div class='cookies-modal-content'><h3 class='mb-4'>Dbamy o Twoją prywatność</h3><div class='container-fluid'><i class='fa-solid fa-cookie-bite fa-5x me-5'></i>";

                message += settings.cookieWarningText;
                message += "</div>"
                message += settings.cookieOptionsContent;
                message += `
                <div class="d-flex justify-content-between cookies-footer mt-4">
                    ${settings.cookieCloseOptionButton}
                    <div></div>
                    <div class="d-flex gap-4">
                        ${settings.cookieOptionButton}
                        ${settings.cookieWarningButton}
                    </div>
                </div>`
                message += "</div></div></div></div>";

                if (message.indexOf("#policy_url_start#") !== -1) {
                    let url = '<a href="' + settings.policyLink + '" target="_blank">',
                        end = "</a>";
                    if (settings.policyLink === null) {
                        url = "";
                        end = "";
                    }

                    message = message.replace("#policy_url_start#", url);
                    message = message.replace("#policy_url_end#", end);
                }

                document.writeln(message);

                $("#fr3ex-closecookie").on("click", function (e) {
                    e.preventDefault();
                    plugin.cookieAcceptAll();
                    $(".cookies-modal-background").css("display", "none");
                    $("body").css("overflow", "visible");
                    $("body").css("overflow-x", "hidden");
                });

                const showOptionsBtn = $(".showOptions")
                let isConsentOptionOpen = false;

                showOptionsBtn.on("click", function (e) {
                    showOptionsBtn.html("Zapisz")
                    $('.closeOptions').removeClass('d-none')
                    $('.consentOptions').removeClass('d-none')

                    if (isConsentOptionOpen && showOptionsBtn.text() === "Zapisz") {
                        if ($('#analitics-cookies').is(":checked")) {
                            plugin.cookieAnaliticsAccept()
                        }

                        if ($('#ads-cookies').is(":checked")) {
                            plugin.cookieAdsAccept()
                        }

                        plugin.cookieNecessaryAccept()
                        plugin.cookieWarningAccept();
                        $(".cookies-modal-background").css("display", "none");
                        $("body").css("overflow", "visible");
                        $("body").css("overflow-x", "hidden");
                    }

                    isConsentOptionOpen = !isConsentOptionOpen;
                })

                $('.closeOptions').on('click', function () {
                    isConsentOptionOpen = !isConsentOptionOpen
                    showOptionsBtn.html('Ustawienia')
                    $('.consentOptions').addClass('d-none')
                    $('.closeOptions').addClass('d-none')
                })

            }),
                (this.cookieWarningAccept = function () {
                    $(document).fr3exCookies("set", "fr3ex-cookie", 1, 365, true);
                    $("#fr3ex-cookiewarning").remove();
                }),
                (this.cookieWarningNotAccept = function () {
                    if (this.cookieWarning_no !== null) {
                        window.location.href = this.cookieWarning_no;
                    }
                }),
                (this.cookieAcceptAll = function () {
                    consentAllAcept()
                    $(document).fr3exCookies("set", "fr3ex-cookie", 1, 365, true);
                    $(document).fr3exCookies("set", "necessary_cookies", 1, 365, true);
                    $(document).fr3exCookies("set", "analitics_cookies", 1, 365, true);
                    $(document).fr3exCookies("set", "ads_cookies", 1, 365, true);
                    $("#fr3ex-cookiewarning").remove();
                }),
                (this.cookieNecessaryAccept = function () {
                    consentGrantedAdStorage()
                    $(document).fr3exCookies("set", "necessary_cookies", 1, 365, true);
                }),
                (this.cookieAnaliticsAccept = function () {
                    consentGrantedAnalyticsStorage()
                    $(document).fr3exCookies("set", "analitics_cookies", 1, 365, true);
                }),
                (this.cookieAdsAccept = function () {
                    consentGrantedAdPersonalization()
                    $(document).fr3exCookies("set", "ads_cookies", 1, 365, true);
                });

            const consentGrantedAdStorage = () => {
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'ad_user_data': 'granted'
                });
            }

            const consentGrantedAdPersonalization = () => {
                gtag('consent', 'update', {
                    'ad_personalization': 'granted',
                })
            }

            const consentGrantedAnalyticsStorage = () => {
                gtag('consent', 'update', {
                    'analytics_storage': 'granted',
                })
            }


            const consentAllAcept = () => {
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'ad_user_data': 'granted',
                    'ad_personalization': 'granted',
                    'analytics_storage': 'granted'
                })
            }


            if (settings.cookieWarning) {
                this.showCookieWarning();
            }
        });
    };
})(jQuery);

if (window.location.pathname !== '/cookies') {
    jQuery(document).fr3exCookies({
        rodo: false,
    });
}


// boostrsap validate
// bootstrapValidate('#email', 'email:Wpisz poprawny adres e-mail');

const applyInputHover = function () {
    $(".float-label .fromInput").each(function () {
        checkInputValue(this);
    });

    if (navigator.userAgent.toLowerCase().indexOf("chrome") >= 0) {
        const _interval = window.setInterval(function () {
            const autofills = $('.float-label input.fromInput:-webkit-autofill');
            if (autofills.length > 0) {
                window.clearInterval(_interval); // stop polling
                autofills.each(function () {
                    checkInputValue(this, true);
                });
            }
        }, 20);
    }
    $(".select-focus").on("change", function () {
        checkInputValue(this);
    });

    // function for set input class if not empty
    $(".fromInput").on("keyup", function () {
        checkInputValue(this);
    }).on('focus', function () {
        const x = $(this);
        if (x.val() === "") {
            x.parent(".float-label").addClass("focus");
        }
    }).on('focusout', function () {
        const x = $(this);
        if (x.val() === "") {
            x.parent(".float-label").removeClass("focus");
        }
    });
}

$(function () {
    // validation
    $("form[data-validate=filters]").each(function (e, item) {
        $(item).validate(validateOptions);
    });

    // input validation
    inputsMask();

    //shipment payment autosubmit
    $('input[type=radio][name=shipmentKindId]').on('change', function () {
        $(this).closest('form').trigger('submit');
    });
    $('input[type=radio][name=paymentMethodId]').on('change', function () {
        $(this).closest('form').trigger('submit');
    });
    $('select[name=productsAmountId]').on('change', function () {
        $(this).closest('form').trigger('submit');
    });
    $('select[name=sortingTypeId]').on('change', function () {
        $(this).closest('form').trigger('submit');
    });

    $('.clearFilters').on('click', function (e) {
        e.preventDefault();
        Pagination.clearPagination();
    });

    // saved fields handlers
    let savedName = "";
    const billSavedAdressElement = $("#billSavedAdress");
    $.each(localStorage, function (key, value) {
        if (key.indexOf("billAddressBook") >= 0) {
            savedName = value.toLowerCase().split(" ").join("");
            billSavedAdressElement.append(
                $("<option>", {
                    value: savedName,
                    text: value,
                })
            );
        }
        billSavedAdressElement.on('change', function () {
            const optVal = $(this).val();
            const savedNameStr = key.replace(optVal, "");

            if (optVal !== "") {
                $(document)
                    .find("#" + savedNameStr)
                    .val(value);
            }
        });
        $("#inneDane").on('click', function () {
            if ($(this).is(":checked")) {
                $("#billForm").show();
            } else {
                $("#billForm").hide();
            }
        });

        const savedAddressElement = $("#savedAddress");
        if (key.indexOf("addAddressBook") >= 0) {
            savedName = value.toLowerCase().split(" ").join("");
            savedAddressElement.append(
                $("<option>", {
                    value: savedName,
                    text: value,
                })
            );
        }
        savedAddressElement.on('change', function () {
            const optVal = $(this).val();
            const savedNameStr = key.replace(optVal, "");

            if (optVal !== "") {
                $(document)
                    .find("#" + savedNameStr)
                    .val(value);
            }
        });

        const invSavedAdressElement = $("#invSavedAdress");
        if (key.indexOf("invAddressBook") >= 0) {
            savedName = value.toLowerCase().split(" ").join("");
            invSavedAdressElement.append(
                $("<option>", {
                    value: savedName,
                    text: value,
                })
            );
        }
        invSavedAdressElement.on('change', function () {
            const optVal = $(this).val();
            const savedNameStr = key.replace(optVal, "");

            if (optVal !== "") {
                $(document)
                    .find("#" + savedNameStr)
                    .val(value);
            }
        });
    });

    // form input hover
    applyInputHover();

    // order wizard
    //Wizard
    InputCheckbox.radioIsCompany(document);
    InputCheckbox.modernRadioFormGroupToggler();
    $('a[data-bs-toggle="tab"]').on("show.bs.tab", function (e) {
        const $target = $(e.target);
        if ($target.parent().hasClass("disabled")) {
            return false;
        }
    });

    $('.password-input-show, .show-password-toggle').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        window.showPass($(this));
    });

});

function changeInputsInfo(obj, name) {
    if (name == "firm") {
        $(obj).closest('form').find('.firm-input').show();
        $(obj).closest('form').find('.private-input').hide();
    } else {
        $(obj).closest('form').find('.firm-input').hide();
        $(obj).closest('form').find('.private-input').show();
    }
}

window.changeInputsInfo = changeInputsInfo;

function editDesc(obj) {
    $(obj)
        .parent()
        .find("textarea.resizable")
        .removeAttr("disabled")
        .removeAttr("readonly");
    $(obj)
        .parent()
        .find("textarea.resizable:not(.cloned)")
        .focus();
}

window.editDesc = editDesc;

function addDesc() {
    $("textarea.resizable").attr("disabled", "");
    $("textarea.resizable").attr("readonly", "");
}

window.addDesc = addDesc;

window.showPass = function (obj) {
    const iconEl = obj.find('span');
    const inputEl = obj.parent().find('input');
    if (inputEl.attr('type') === 'password') {
        inputEl.attr('type', 'text');
        iconEl.text('Ukryj');
        iconEl.attr('title', 'Ukryj hasło');
    } else {
        inputEl.attr('type', 'password');
        iconEl.text('Pokaż');
        iconEl.attr('title', 'Pokaż hasło');
    }
}


function checkActive() {
    if ($('.product-section').length && $('.nav-horizontal-list').length) {
        let activeSection = null;
        $('.product-section').each(function (index, item) {
            const el = $(item);
            const topSection = el.get(0).getBoundingClientRect().y;
            const bottomSection = el.get(0).getBoundingClientRect().bottom;
            const centerPage = $(window).height() / 2;

            if (topSection < centerPage && centerPage < bottomSection) {
                activeSection = el.attr('id');
            }
        });
        if (activeSection != null) {
            $('.nav-horizontal-list a').removeClass('active');
            $('.nav-horizontal-list a[href="#' + activeSection + '"]').addClass('active');
        }
    }
}

window.checkActive = checkActive;

$(window).on('load resize scroll', function () {
    checkActive();
});


function imageZoom(imgObj, resultID) {
    let cx, cy;
    const img = imgObj[0];
    /* Create lens: */
    const lens = document.createElement("DIV");
    const result = document.getElementById(resultID);
    if (img !== null && result !== null) {
        const imgContainer = img.parentElement.parentElement.parentElement;
        const deltaX = Math.max(0, (imgContainer.offsetWidth - img.offsetWidth) / 2);
        const deltaY = Math.max(0, (imgContainer.offsetHeight - img.offsetHeight) / 2);
        lens.setAttribute("class", "img-zoom-lens");
        lens.style.left = deltaX + (deltaX > 0 ? 'px' : '');
        lens.style.top = deltaY + (deltaY > 0 ? 'px' : '');
        /* Insert lens: */
        img.parentElement.insertBefore(lens, img);
        //img.appendChild(lens);
        /* Set background properties for the result DIV */
        result.style.backgroundImage = "url('" + imgObj.data('zoomUri') + "')";
        lens.style.width = (100 * (result.offsetWidth / result.offsetHeight)) + "px";
        /* Calculate the ratio between result DIV and lens: */
        cx = result.offsetWidth / lens.offsetWidth;
        cy = result.offsetHeight / lens.offsetHeight;
        result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
        /* Execute a function when someone moves the cursor over the image, or the lens: */
        lens.addEventListener("mousemove", moveLens);
        img.parentElement.addEventListener("mousemove", moveLens);
        /* And also for touch screens: */
        lens.addEventListener("touchmove", moveLens);
        img.parentElement.addEventListener("touchmove", moveLens);

        function moveLens(e) {
            /* Prevent any other actions that may occur when moving over the image */
            e.preventDefault();

            /* Get the cursor's x and y positions: */
            const pos = getCursorPos(e);
            /* Set the position of the lens: */
            const left = pos.x - (lens.offsetWidth / 2);
            const top = pos.y - (lens.offsetHeight / 2);
            lens.style.left = deltaX + Math.min(Math.max(left, 0), img.width - lens.offsetWidth) + (left > 0 ? 'px' : '');
            lens.style.top = deltaY + Math.min(Math.max(top, 0), img.height - lens.offsetHeight) + (top > 0 ? 'px' : '');

            /* Display what the lens "sees": */
            const x = Math.max(0, Math.min(pos.x - (lens.offsetWidth / 2), img.width - lens.offsetWidth));
            const y = Math.max(0, Math.min(pos.y - (lens.offsetHeight / 2), img.height - lens.offsetHeight));
            result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
        }

        function getCursorPos(e) {
            let a, x = 0, y = 0;
            //e = e || window.event;
            /* Get the x and y positions of the image: */
            a = img.getBoundingClientRect();
            /* Calculate the cursor's x and y coordinates, relative to the image: */
            x = e.pageX - a.left;
            y = e.pageY - a.top;
            /* Consider any page scrolling: */
            x = x - window.scrollX;
            y = y - window.scrollY;
            return { x: x, y: y };
        }
    }
}

window.imageZoom = imageZoom;

const minimumContentHeight = function () {
    const contentMinHeight = $('.content-min-size, [data-app-content="setMinHeight"]');
    if (contentMinHeight.length === 1) {
        const min = $(window).height() - ($('header').outerHeight() || 0) - ($('footer:visible').outerHeight() || 0) - ($('.sticky-menu-container:visible').outerHeight() || 0);
        contentMinHeight.css('min-height', min);
    }
}

$(window).on('resize', function () {
    minimumContentHeight();
});

$(".toggle-promocode").on("click", function (e) {
    e.preventDefault();
    $(this).addClass('d-none');
    $("#promoCodeBox").toggle();
});



//product range slider
//github.com/stbaer/rangeslider-js
$(function () {
    $("form.search").on('focusin', function () {
        $("#search").closest("form.search").addClass('focused-on');
        $(".search-bg").addClass('active');
    });
    $(".search-bg").on('click', function () {
        $("#search").closest("form.search").removeClass('focused-on');
        $(".search-bg").removeClass('active');
    });

    $(".offer-list-menu").find("li").hide();
    $('textarea.resizable').each(function () {
        $(this)
            .removeAttr("disabled")
            .removeAttr("readonly")
            .trigger('focus')
            .trigger('focusout')
            .attr("disabled", "")
            .attr("readonly", "");
    });

    $('.account-side-menu-button').on('click', function () {
        $(this).siblings('ul').find("li").toggle();
        $(this).toggleClass('active');
    });
    $('.account-side-menu-item').each(function (e, item) {
        const el = $(item);
        if (el.hasClass('active')) {
            el.parent().find('li').toggle();
            $(this).parent().siblings('span').toggleClass('active');
        }
    });

    minimumContentHeight();

    $('[data-bs-toggle="tooltip"]').tooltip();

    InputCart.rangeSliderJs();
});

jQuery(function () {
    $('.scrollToElement').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let id = $(this).attr('href');
        let to = $(id).position().top - $('body > header').height() - 2;
        window.scrollTo({
            top: to,
            behavior: "smooth"
        });
    });
});
